import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { STAFF, BRAND_LOGO_NAVY, PRIMARY_CTA } from "@/lib/data";

const Team = () => {
  return (
    <main data-testid="page-team">
      <PageHero
        eyebrow="Meet the Team"
        title="The people behind the work."
        intro="A small, senior team that owns the work end to end across DC, Maryland, and Virginia."
      />

      <section className="section bg-white" data-testid="team-grid">
        <div className="container-kc">
          <Reveal>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 items-end">
              <div className="lg:col-span-7">
                <div className="flex items-center gap-3 mb-6">
                  <span className="hairline--gold" />
                  <span className="eyebrow">Regional Leadership</span>
                </div>
                <h2 className="h-display text-3xl md:text-5xl">Three regions. One standard.</h2>
              </div>
              <div className="lg:col-span-5">
                <p className="text-gray-600 leading-relaxed">
                  Each region is led by senior practitioners with direct ownership of strategy, resident services, compliance, and on-the-ground execution.
                </p>
              </div>
            </div>
          </Reveal>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-gray-200">
            {STAFF.map((member, idx) => (
              <Reveal key={idx} delay={idx * 0.06}>
                <div className="bg-white p-8 lg:p-10 h-full flex flex-col" data-testid={`team-card-${idx}`}>
                  <div className="aspect-[4/5] bg-[#F8F9FA] border border-gray-200 mb-6 relative overflow-hidden">
                    {member.image ? (
                      <img
                        src={member.image}
                        alt={member.name}
                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                        loading="lazy"
                      />
                    ) : (
                      <div className="absolute inset-0 flex items-center justify-center">
                        <img src={BRAND_LOGO_NAVY} alt="Kassim Consulting" className="h-20 w-auto opacity-60" />
                        <span className="absolute bottom-3 left-3 text-[10px] tracking-[0.18em] uppercase text-gray-400">Photo coming soon</span>
                      </div>
                    )}
                  </div>
                  <h3 className="font-serif text-2xl text-[#000000] leading-snug">{member.name}</h3>
                  <p className="text-[12px] tracking-[0.15em] uppercase text-[#C5A880] font-semibold mt-2">{member.role}</p>
                  <p className="text-gray-600 mt-4 text-[14px] leading-relaxed">{member.bio}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#000000] text-white">
        <div className="container-kc py-24 md:py-32">
          <Reveal>
            <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
              <div className="md:col-span-8">
                <div className="eyebrow eyebrow--gold mb-4">Work With Our Team</div>
                <h2 className="h-display h-display--inverse text-3xl md:text-5xl">
                  Bring your next relocation to a partner who has delivered.
                </h2>
              </div>
              <div className="md:col-span-4 flex md:justify-end">
                <Link to={PRIMARY_CTA.to} className="btn btn--inverse" data-testid="team-cta">
                  {PRIMARY_CTA.label} <span className="btn-arrow">→</span>
                </Link>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default Team;
